"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const yup = __importStar(require("yup"));
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const yup_1 = require("@hookform/resolvers/yup");
const auth_api_1 = require("../../../utils/api/auth/auth.api");
const Utils_1 = require("../../../utils/Utils");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const COOLDOWN_DURATION = 90;
const UseResendCodeForm = () => {
    const [cooldown, setCooldown] = (0, react_1.useState)(null);
    const [resendCode, { isLoading }] = (0, auth_api_1.useResendVerifyUserMutation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const validationSchema = yup.object().shape({
        email: yup
            .string()
            .email()
            .required("L'email est requis")
            .label("Email"),
    });
    const { register, handleSubmit, formState: { errors }, clearErrors, setValue, getValues, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const state = (0, react_router_dom_1.useLocation)().state;
    (0, react_1.useEffect)(() => {
        if (state === null || state === void 0 ? void 0 : state.email) {
            setValue("email", state.email);
        }
        else {
            setTimeout(() => navigate("/"), 1);
        }
    }, [state === null || state === void 0 ? void 0 : state.email]);
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    (0, react_1.useEffect)(() => {
        const storedTime = localStorage.getItem("resend_timer_start");
        if (storedTime) {
            const elapsed = Math.floor((Date.now() - parseInt(storedTime, 10)) / 1000);
            const remaining = COOLDOWN_DURATION - elapsed;
            setCooldown(remaining > 0 ? remaining : 0);
        }
        else {
            setCooldown(0);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (cooldown === null)
            return;
        let timer;
        if (cooldown > 0) {
            timer = setTimeout(() => setCooldown((prev) => (prev ? prev - 1 : 0)), 1000);
        }
        else {
            localStorage.removeItem("resend_timer_start");
        }
        return () => clearTimeout(timer);
    }, [cooldown]);
    const handleSubmitCode = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (cooldown && cooldown > 0)
            return;
        try {
            const res = yield resendCode(data.email);
            if ("data" in res && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.success) === true) {
                react_hot_toast_1.default.success(res.data.message || "Code renvoyé !");
                const now = Date.now();
                localStorage.setItem("resend_timer_start", now.toString());
                setCooldown(COOLDOWN_DURATION);
            }
            else {
                react_hot_toast_1.default.error(((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message) || "Une erreur est survenue.");
            }
        }
        catch (err) {
            react_hot_toast_1.default.error("Erreur lors de l'envoi du code.");
        }
    });
    return {
        register,
        errors,
        onSubmit: handleSubmit(handleSubmitCode),
        isLoading,
        cooldown: cooldown !== null && cooldown !== void 0 ? cooldown : 0,
    };
};
exports.default = UseResendCodeForm;
